export default __webpack_public_path__ + "static/media/DCC-Logo.cf5b3ffe.svg";